/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const wordFamilyFormSchema = z.object({
  word: z.string(),
  pos: z.string(),
});

export const wordFamilySchema = z.object({
  forms: z.array(wordFamilyFormSchema),
});

export type IWordFamily = z.infer<typeof wordFamilySchema>;
